import { gql } from 'graphql-tag';
import { AD_TARGETING_FRAGMENT } from './adTargeting.fragment';
import { ANALYTICS_ECCOMERCE_FRAGMENT } from './analyticsEcommerce.fragment';
import { ANALYTICS_TAXONOMY_FRAGMENT } from './analyticTaxonomy.fragment';
import { LINKS_FRAGMENT } from './links.fragment';
import { LISTING_MAP_FRAGMENT } from './listingMap.fragment';
import { META_INFO_FRAGMENT } from './metaInfo.fragment';
import { PAGINATION_FRAGMENT } from './pagination.fragment';
import { POLYGON_FRAGMENT } from './polygon.fragment';
import { SAVED_SEARCH_AND_ALERTS_FRAGMENT } from './savedSearchAndAlerts.fragment';
import { SEO_BLURB_FRAGMENT } from './seoBlurb.fragment';

export const LISTING_MAP_VIEW_QUERY = gql`
    ${ANALYTICS_TAXONOMY_FRAGMENT}
    ${AD_TARGETING_FRAGMENT}
    ${ANALYTICS_ECCOMERCE_FRAGMENT}
    ${META_INFO_FRAGMENT}
    ${PAGINATION_FRAGMENT}
    ${LISTING_MAP_FRAGMENT}
    ${LINKS_FRAGMENT}
    ${POLYGON_FRAGMENT}
    ${SEO_BLURB_FRAGMENT}
    ${SAVED_SEARCH_AND_ALERTS_FRAGMENT}

    query getListingMapView($path: String!) {
        searchResults(path: $path) {
            analyticsTaxonomy {
                ...ANALYTICS_TAXONOMY_FRAGMENT
            }
            analyticsEcommerce {
                ...ANALYTICS_ECCOMERCE_FRAGMENT
            }
            metaInfo {
                ...META_INFO_FRAGMENT
            }
            pagination {
                ...PAGINATION_FRAGMENT
            }
            listings {
                regular {
                    ...LISTING_MAP_FRAGMENT
                }
                featured {
                    ...LISTING_MAP_FRAGMENT
                }
                extended {
                    ...LISTING_MAP_FRAGMENT
                }
            }
            seoBlurb {
                ...SEO_BLURB_FRAGMENT
            }
            links {
                ...LINKS_FRAGMENT
            }
            polygonV2(path: $path) {
                ...POLYGON_FRAGMENT
            }
            polyenc
        }
    }
`;
